import { PushNotifications } from '@capacitor/push-notifications';

export async function initPush(userId: string) {
  // 1) Demander l'autorisation
  const perm = await PushNotifications.requestPermissions();
  if (perm.receive !== 'granted') return;

  // 2) Écouteurs AVANT register
  PushNotifications.addListener('registration', async (t) => {
    console.log('APNs token:', t.value);
    // 3) Enregistrer le token sur le backend
    try {
      await fetch(import.meta.env.VITE_API_BASE + '/devices/register', {
        method: 'POST',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({
          userId,
          platform: 'ios',
          env: import.meta.env.MODE === 'production' ? 'prod' : 'dev',
          token: t.value,
          bundleId: 'get-clan.com'
        })
      });
    } catch (error) {
      console.error('Failed to register token with backend:', error);
    }
  });

  PushNotifications.addListener('registrationError', (e) => {
    console.error('registrationError', e);
  });

  PushNotifications.addListener('pushNotificationReceived', (n) => {
    console.log('🔔 Received (foreground):', n);
  });

  await PushNotifications.register();
}
